<style lang="scss" src="./Project.scss"></style>

<template>
    <article class="project-container">
        <div class="project-content">
            <div class="l-description">
                <div class="l-wrapper">
                    <template v-if="projectData.description[$translate.lang].half1">
                        <article class="infos-item iefix is-scrollAnimated is-lightlyAnimated is-visible">
                            <h3 class="item-title">{{ t('about') }}</h3>
                            <div class="l-wrapper l-doubleColumn">
                                <div class="item-content l-half">
                                    <p v-for="value of projectData.description[$translate.lang].half1" v-html="value" class="project-description" v-bind:key="value.title"></p>
                                </div>
                                <div class="item-content l-half">
                                    <p v-for="value of projectData.description[$translate.lang].half2" v-html="value" class="project-description" v-bind:key="value.title"></p>
                                </div>
                            </div>
                        </article>
                    </template>
                    <template v-else>
                        <article class="infos-item l-half is-scrollAnimated is-lightlyAnimated is-visible">
                            <h3 class="item-title">{{ t('about') }}</h3>
                            <div class="item-content">
                                <p v-for="value of projectData.description[$translate.lang]" v-html="value" class="project-description" v-bind:key="value.title"></p>
                            </div>
                        </article>
                    </template>
                </div>
                
                <div class="l-wrapper">
                    <article class="infos-item skills-item is-scrollAnimated is-lightlyAnimated">
                        <h3 class="item-title">{{ t('skills') }}</h3>
                        <div class="item-content">
                            <ul class="list list--tertiary list--skills" v-if="projectData.skills">
                                <li class="list-item" v-for="(value) of projectData.skills" v-bind:key="value.title">
                                    <span class="item-gradient">{{value}}</span>
                                </li>
                            </ul>
                        </div>
                    </article>
                </div>
            </div>
            
            <div class="l-wrapper">
                <template v-if="projectData.fullVideo && projectData.fullImage && !this.app.isMobile">
                    <video loop :poster="imagesFolder + projectData.fullImage" class="is-scrollAnimated" muted>
                        <source :src="imagesFolder + projectData.fullVideo" type="video/mp4">
                    </video> 
                </template>
                <template v-else>
                    <template v-if="projectData.fullImage">
                        <img :src="imagesFolder + projectData.fullImage" class="is-scrollAnimated">
                    </template>
                </template>
            </div>

            <div class="l-wrapper">
                <template v-if="projectData.fullVideo2 && projectData.fullImage2 && !this.app.isMobile">
                    <video loop :poster="imagesFolder + projectData.fullImage2" class="is-scrollAnimated" muted>
                        <source :src="imagesFolder + projectData.fullVideo2" type="video/mp4">
                    </video> 
                </template>
                <template v-else>
                    <template v-if="projectData.fullImage2">
                        <img :src="imagesFolder + projectData.fullImage2" class="is-scrollAnimated">
                    </template>
                </template>
            </div>

            <div class="l-wrapper l-videos" v-if="projectData.half1Image || projectData.half2Image">
                <div class="l-half">
                    <template v-if="projectData.half1Video.split('.').pop() === 'mp4' && projectData.half1Image && !this.app.isMobile">
                        <video loop :poster="imagesFolder + projectData.half1Image" class="is-scrollAnimated" muted>
                            <source :src="imagesFolder + projectData.half1Video" type="video/mp4">
                        </video> 
                    </template>
                    <template v-else>
                        <img :src="imagesFolder + projectData.half1Image" class="is-scrollAnimated">
                    </template>
                </div>
                <div class="l-half">
                    <template v-if="projectData.half2Video.split('.').pop() === 'mp4' && projectData.half2Image && !this.app.isMobile">
                        <video loop :poster="imagesFolder + projectData.half2Image" class="is-scrollAnimated" muted>
                            <source :src="imagesFolder + projectData.half2Video" type="video/mp4">
                        </video> 
                    </template>
                    <template v-else>
                        <img :src="imagesFolder + projectData.half2Image" class="is-scrollAnimated">
                    </template>
                </div>
            </div>

            <div class="l-wrapper l-mobile" v-if="projectData.mobile1Image || projectData.mobile2Image">
                <div class="l-half">
                    <template v-if="projectData.mobile1Video.split('.').pop() === 'mp4' && projectData.mobile1Image && !this.app.isMobile">
                        <div class="item-container is-scrollAnimated is-videoContainer">
                            <img src="/static/images/phone.svg" />
                            <video loop :poster="imagesFolder + projectData.mobile1Image" class="item-content" muted>
                                <source :src="imagesFolder + projectData.mobile1Video" type="video/mp4">
                            </video> 
                        </div>
                    </template>
                    <template v-else>
                        <div class="item-container">
                            <img :src="imagesFolder + projectData.mobile1Image" class="item-content is-scrollAnimated">
                        </div>
                    </template>
                </div>
                <div class="l-half">
                    <template v-if="projectData.mobile2Video.split('.').pop() === 'mp4' && projectData.mobile2Image && !this.app.isMobile">
                        <div class="item-container is-scrollAnimated is-videoContainer">
                            <img src="/static/images/phone.svg" />
                            <video loop :poster="imagesFolder + projectData.mobile2Image" class="item-content" muted>
                                <source :src="imagesFolder + projectData.mobile2Video" type="video/mp4">
                            </video> 
                        </div>
                    </template>
                    <template v-else>
                        <div class="item-container">
                            <img :src="imagesFolder + projectData.mobile2Image" class="item-content is-scrollAnimated">
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <footer class="project-url is-scrollAnimated is-lightlyAnimated nomargin" v-bind:class="{'no-website': !projectData.url}">
            <a class="btn c-hover hover-wave" v-if="projectData.url" :href="projectData.url" target="_blank">
                <span class="c-hover" v-for="(letter, index) in ($translate.locale.seeproject.split(''))" v-bind:class="{'l-inline': letter === ' '}" v-bind:key="index">{{ letter }}</span>
            </a>
            <a @click.prevent="loadPreviousProject" v-on:mouseenter="initHoverAnimation" v-on:mouseleave="initUnhoverAnimation" :href="previousProjectPath" class="url-zone zone-prev c-hover">
                <span class="zone-text c-hover">
                    <span class="c-hover" v-for="(letter, index) in (t('previous project').split(''))" v-bind:class="{'l-inline': letter === ' '}" v-bind:key="index">{{ letter }}</span>
                </span>
            </a>
            <a @click.prevent="loadNextProject" v-on:mouseenter="initHoverAnimation" v-on:mouseleave="initUnhoverAnimation" :href="nextProjectPath" class="url-zone zone-next c-hover">
                <span class="zone-text c-hover">
                    <span class="c-hover" v-for="(letter, index) in (t('next project').split(''))" v-bind:class="{'l-inline': letter === ' '}" v-bind:key="index">{{ letter }}</span>
                </span>
            </a>
        </footer>
    </article>
</template>

<script>

    import projects from '../../data/projects.json'

    export default {
                
        data() {
            return {
                imagesFolder:  '/static/images/projects/' + this.$route.params.projectId + '/',
                projectData: projects[this.$route.params.projectId],
                cover: `/static/images/projects/${projects[this.$route.params.projectId].cover}`,
                app: this.$parent.$parent,
                fromPageAbout: false,
                loaderRef: this.$parent.$parent.$refs.appbase.$refs.loader,
                isRouteChanging: false,
                previousProject: false,
                previousProjectPath: '',
                nextProject: false,
                nextProjectPath: ''
            }
        },
        
        metaInfo () {
            return {
                title: 'Julien Barreira',
                titleTemplate: '%s - ' + this.projectData.title[this.$translate.lang][0] + ' ' + this.projectData.title[this.$translate.lang][1]
            }
        },
        
        locales: {
            en: {
                'seeproject': 'View website',
                'about': 'About',
                'skills': 'Skills',
                'previous project': 'previous project',
                'next project': 'next project'
            },
            fr: {
                'seeproject': 'Voir le site',
                'about': 'À propos',
                'skills': 'Compétences',
                'previous project': 'projet précédent',
                'next project': 'projet suivant'
            }
        },
        
        mounted () {
            document.getElementById('slider-projects').querySelector('[data-name=' + this.$route.params.projectId +']').classList.add('is-active')
            
            // pour éviter bug en cas de changement de page en plein switch full/list
            this.$parent.isAnimating = false            
            
            // pour éviter bug de calcul de hauteur avant que les videos soient rendered
            var self  = this
            this.$nextTick(function () {
                setTimeout(function() {
                    if (!self.app.firstLoad && !self.$parent.projectLoaded && !self.app.isMobile) {
                        self.app.launchSmoothScroll()
                    }
                    
                    self.openProject()
                    
                }, 100);
            })
            
            // On resize
            window.addEventListener('resize', this.resizeCanvas)
            
            // pour passage d'un projet à l'autre
            this.getProjectsRoutes()
            var projectsArray = JSON.parse(JSON.stringify(projects))
            var projectPosition = Object.keys(projectsArray).map(function(e) {return e}).indexOf(this.$route.params.projectId)
            var nextProjectId = projectPosition + 1
            if (nextProjectId >= 4) {
                nextProjectId = 0
            }
            
            // pour effet hover liens
            if (!this.app.isMobile) {
                this.app.initTextHover()
            }
        },
        
        updated() {
            this.isRouteChanging = false;
            
            if (!this.app.firstLoad && this.app.smoothScroll) {
                this.app.smoothScroll.onResize();
            }
            
            this.app.$refs.appbase.$refs.loader.logoLink = this.app.$refs.appbase.projectsPath
            
            this.getProjectsRoutes()
        },
        
        beforeRouteEnter (to, from, next) {
            
            if (from.name === 'about_component') {                
                vm => {
                    vm.app.$refs.appbase.$refs.loader.LoadAnimationRemove()
                }
            }
            
            next(vm => {
                // pour changer le lien du logo vers la page projets
                vm.app.$refs.appbase.$refs.loader.logoLink = vm.app.$refs.appbase.projectsPath
            })
        },
        
        beforeRouteLeave (to, from, next) {
            if (!this.isRouteChanging) {
                this.isRouteChanging = true
                
                next(false)
                
                
                if (to.name === 'projects_component') {
                    if (from.path.includes('/fr/')) {
                        if (to.path.includes('/fr')) {
                            this.backToSameLang(next)
                        } else {
                            this.backToAnotherLang(next, to)
                        }
                    } else {
                        if (to.path.includes('/fr')) {
                            this.backToAnotherLang(next, to)
                        } else {
                            this.backToSameLang(next)
                        }
                    }
                    
                } else if (to.name === 'project_component') {
                    next()
                } else {                    
                    if (this.app.isMobile) {
                        setTimeout(function() {                        
                            document.documentElement.scrollTop = 0
                            document.body.scrollTop = 0
                        }, 700)
                    }

                    window.removeEventListener('resize', this.resizeCanvas)
                    this.leaveRoute(next)
                }
                
            } else {
                next()
            }
        },
        
        methods: {
            leaveRoute(next) {
                if (!this.app.isMobile) {                    
                    this.app.resetScroll()
                }
                this.closeProject()
                
                next()
                
                if (this.previousProject !== false) {
                    var self = this;
                    
                    setTimeout(function() {
                        if (!self.app.isMobile) {                            
                            self.$parent.initCanvasSlideshow.previousSlide(self.$parent.$children[self.previousProject].loadProjectCondition)
                            self.showLoaderPercent()
                        } else {
                            self.$parent.$children[self.previousProject].loadProjectCondition()
                            self.showLoaderPercent()
                        }
                    }, 100)
                } else if (this.nextProject !== false) {
                    var self = this;
                    
                    setTimeout(function() {
                        if (!self.app.isMobile) {                            
                            self.$parent.initCanvasSlideshow.nextSlide(self.$parent.$children[self.nextProject].loadProjectCondition)
                            self.showLoaderPercent()
                            
                        } else {
                            self.$parent.$children[self.nextProject].loadProjectCondition()
                            self.showLoaderPercent()
                        }
                    }, 100)
                }
            },
            openProject() {
                
                if (!this.app.firstLoad) {
                    this.loaderRef.isLoading = false
                }
                
                this.loaderRef.isMaskDisabled = false
                this.loaderRef.loaderWidth = 0
                
                this.$parent.projectLoading = false;
                this.$parent.projectLoaded = true
            },
            
            closeProject() {
                this.$parent.projectLoaded = false
            },
            
            scrollTopNative(next) {
                const   scrollHeight = window.scrollY,
                        scrollStep = Math.PI / ( 500 / 15 ),
                        cosParameter = scrollHeight / 2;
                var     self = this,
                        scrollCount = 0,
                        scrollMargin,
                        scrollInterval = setInterval( function() {
                            if ( window.scrollY != 0 ) {
                                scrollCount = scrollCount + 1;  
                                scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
                                window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
                            } 
                            else {
                                clearInterval(scrollInterval);
                                self.closeProject()
                                next()
                            }
                        }, 15 );
            },
            
            backToSameLang(next) {
                var self = this
                this.loaderRef.isLoading = true
                    
                if (!this.app.isMobile) {                        
                    this.app.smoothScroll.off()
                    this.app.smoothScroll.scrollTo(0, function() {                
                        self.leaveRoute(next)
                        self.$parent.initCanvasSlideshow.listenScroll()
                        self.$parent.initCanvasSlideshow.startTicker()
                        self.loaderRef.isLoading = false
                    })
                } else {
                    this.scrollTopNative(function() {
                        self.leaveRoute(next)
                    })
                    this.loaderRef.isLoading = false
                    document.getElementById('slider-projects').querySelector('[data-name=' + this.$route.params.projectId +']').classList.remove('is-active')
                }
            },
            
            backToAnotherLang(next, to) {
                var self = this
                this.app.$refs.appbase.$refs.loader.LoadAnimationAdd()
                
                setTimeout(function () {
                    if (!self.app.isMobile) {                        
                        self.app.smoothScroll.off()
                        self.app.smoothScroll.scrollTo(0, function() {                
                            self.leaveRoute(next)
                            self.$parent.initCanvasSlideshow.listenScroll()
                            self.$parent.initCanvasSlideshow.startTicker()
                            self.loaderRef.isLoading = false
                        })
                    } else {
                        self.scrollTopNative(next)
                        self.loaderRef.isLoading = false
                        if (!self.app.isMobile) {                            
                            document.getElementById('slider-projects').querySelector('[data-name=' + this.$route.params.projectId +']').classList.remove('is-active')
                        }
                    }
                    
                    if (to.path.includes('/fr')) {
                        self.$translate.setLang('fr')
                        self.app.$refs.appbase.isEng = false
                    } else {
                        self.$translate.setLang('en')
                        self.app.$refs.appbase.isEng = true
                    }
                    
                    self.app.$refs.appbase.setLinksPath()
                    self.app.$refs.appbase.$refs.loader.LoadAnimationRemove()
                }, 800)
            },
            
            resizeCanvas: function() {                
                if (window.innerWidth < 1025 && this.$route.params.projectId) {
                    document.getElementById('slider-projects').querySelector('[data-name=' + this.$route.params.projectId +']').classList.add('is-active')
                }
            },
            
            getProjectsRoutes: function() {
                var self = this;
                
                setTimeout(function() {                    
                    var nextProjectId = self.getNextProjectId()
                    self.nextProjectPath = self.$parent.$children[nextProjectId].projectPath

                    var previousProjectId = self.getPreviousProjectId()
                    self.previousProjectPath = self.$parent.$children[previousProjectId].projectPath
                }, 100)
            },
            
            loadNextProject: function() {
                var nextProjectId = this.getNextProjectId()
                
                if(!this.loaderRef.isLoading) {
                    this.$router.push({path: this.$parent.$parent.$refs.appbase.projectsPath})
                    
                    this.nextProject = nextProjectId
                }
            },
            
            loadPreviousProject: function() {
                var previousProjectId = this.getPreviousProjectId()
                
                if(!this.loaderRef.isLoading) {
                    this.$router.push({path: this.$parent.$parent.$refs.appbase.projectsPath})
                    
                    this.previousProject = previousProjectId
                }
            },
            
            getNextProjectId: function() {
                var projectsArray = JSON.parse(JSON.stringify(projects))
                var projectPosition = Object.keys(projectsArray).map(function(e) {return e}).indexOf(this.$route.params.projectId)
                var nextProjectId = projectPosition + 1
                if (nextProjectId >= 4) {
                    nextProjectId = 0
                }
                
                return nextProjectId
            },
            
            getPreviousProjectId: function() {
                var projectsArray = JSON.parse(JSON.stringify(projects))
                var projectPosition = Object.keys(projectsArray).map(function(e) {return e}).indexOf(this.$route.params.projectId)
                var previousProjectId = projectPosition - 1
                if (previousProjectId < 0) {
                    previousProjectId = 3
                }
                
                return previousProjectId
            },
            
            initHoverAnimation: function(event) {
                if (!this.app.isMobile) {                    
                    var targets = event.target.querySelectorAll(".zone-text span")

                    TweenMax.staggerTo(targets, 0, {
                        x: -5,
                        y: -5,
                        autoAlpha: 0
                    }, 0)
                    TweenMax.staggerTo(targets, 0.2, {
                        x: 0,
                        y: 0,
                        autoAlpha: 1
                    }, 0.04)
                }
            },
            
            initUnhoverAnimation: function(event) {
                if (!this.app.isMobile) {
                    TweenMax.staggerTo(event.target.querySelectorAll(".zone-text span"), 0.2, {
                        x: 5,
                        y: 5,
                        autoAlpha: 0
                    }, 0.04)
                }
            },
            
            showLoaderPercent: function(event) {
                var self = this;
                
                setTimeout(function() {
                    self.loaderRef.percentLoaded = 0
                    self.loaderRef.loaderVisible = true
                }, 400)
            }

        }        

    }

</script>


// WEBPACK FOOTER //
// src/components/Project/Project.vue